import React from 'react';
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { SelectProductType, SelectTerritorialUnits } from "../../../../components/selects";
import SelectCitizenship from "../../../../components/selects/SelectCitizenship";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

const months = [
  { value: 1, label: "Январь" },
  { value: 2, label: "Февраль" },
  { value: 3, label: "Март" },
  { value: 4, label: "Апрель" },
  { value: 5, label: "Май" },
  { value: 6, label: "Июнь" },
  { value: 7, label: "Июль" },
  { value: 8, label: "Август" },
  { value: 9, label: "Сентябрь" },
  { value: 10, label: "Октябрь" },
  { value: 11, label: "Ноябрь" },
  { value: 12, label: "Декабрь" },
];

const operationOptions = [
  { label: "Импорт", value: "IMPORT" },
  { label: "Экспорт", value: "EXPORT" },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 10 }, (_, index) => currentYear - index);

export const FilterTradeRegistry = (props: IProps) => {
  const { t } = useTranslation();

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ [8, 8] }>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('year') }
			name={ props.formField.year }
		  >
			<Select
			  placeholder={ t("msg.selectPlaceholder") }
			  allowClear
			>
			  { years.map((year) => (
				<Select.Option key={ year } value={ year }>
				  { year }
				</Select.Option>
			  )) }
			</Select>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Месяц') }
			name={ props.formField.month }
		  >
			<Select
			  placeholder={ t("msg.selectPlaceholder") }
			  allowClear
			  options={ months }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Тип торговли') }
			name={ props.formField.tradeType }
		  >
			<Select
			  placeholder={ t("Выберите тип торговли") }
			  options={ operationOptions }
			  allowClear
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Область') }
			name={ props.formField.citizenshipId }
		  >
			<SelectCitizenship/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Вид продукции') }
			name={ props.formField.productTypeId }
		  >
			<SelectProductType/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Регион отгрузки') }
			name={ props.formField.regionOfDispatchId }
		  >
			<SelectTerritorialUnits/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Регион прибытия') }
			name={ props.formField.regionOfArrivalId }
		  >
			<SelectTerritorialUnits/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 24 } md={ 24 } lg={ 24 }>
		  <div style={ { marginTop: 4 } }>
			<Button
			  type="primary"
			  shape="default"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 8 } }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  );
};
